import { render, staticRenderFns } from "./UsdPage.vue?vue&type=template&id=fc366c20&scoped=true&"
import script from "./UsdPage.vue?vue&type=script&lang=js&"
export * from "./UsdPage.vue?vue&type=script&lang=js&"
import style0 from "./UsdPage.vue?vue&type=style&index=0&id=fc366c20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc366c20",
  null
  
)

export default component.exports